// Generated from SVG to Code Figma Plugin

export const ProductLineElement = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M21.1626 7.85491C21.1626 6.93711 20.6245 6.10456 19.7878 5.72754L12.9625 2.65234C12.3508 2.37672 11.6501 2.37777 11.0392 2.6552L4.27865 5.72548C3.44528 6.10396 2.91016 6.93471 2.91016 7.84999V16.1456C2.91016 17.0609 3.44526 17.8916 4.27859 18.2701L11.0391 21.3406C11.65 21.618 12.3508 21.6191 12.9626 21.3434L19.7878 18.268C20.6246 17.891 21.1626 17.0585 21.1626 16.1407V7.85491Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M7.0332 9.39551L11.9959 11.8022L16.9641 9.39551"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.60374"
    />
    <path d="M12 11.8076V17.3955" stroke="currentColor" strokeLinecap="round" strokeWidth="1.60374" />
  </svg>
);
